export const CookieLink = ({ text }: { text: string }) => {
  return (
    <button
      type="button"
      onClick={() => {
        const CookieScript = (window as any)?.CookieScript;
        if (!CookieScript) return;
        CookieScript.instance.show();
      }}
    >
      {text}
    </button>
  );
};
